<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="visatype" class="col-md-2">Type de visa:</label>
          <select
            id="visatype"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !price.visatype }"
            v-model="price.visatype"
          >
            <option disabled value="">Sélectionner un type de visa...</option>
            <option v-for="v in visatypes" :value="v.id" :key="v.id">
              {{
                v.name
                  ? `${v.name}-Evisa-${v.duration} jours-${
                      v.entry_mode === "SINGLE"
                        ? "Entrée simple"
                        : "Entrée multiple"
                    }`
                  : `Evisa-${v.duration} jours-${
                      v.entry_mode === "SINGLE"
                        ? "Entrée simple"
                        : "Entrée multiple"
                    }`
              }}
            </option>
            <!-- <option value="UNAUTHORIZED">NON AUTHORISE</option> -->
          </select>
          <!-- <div v-show="submitted && !price.visatype" class="invalid-feedback">
            Type de visa requis
          </div> -->
        </div>

        <!-- <div class="form-group row">
          <label for="country" class="col-md-2">Pays</label>
          <select
            id="country"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !price.country }"
            v-model="price.country"
          >
            <option disabled value="">Sélectionner un pays...</option>
            <option v-for="c in countries" :value="c.id" :key="c.id">
              {{ c.name }}
            </option>
          </select>
        </div> -->

        <div class="form-group row">
          <label for="country" class="col-md-2">Pays:</label>
          <v-select
            id="country"
            class="col-md-8"
            v-model="price.country"
            :options="countries"
            label="name"
            :reduce="(country) => country.id"
            style="padding: 0"
          >
          </v-select>
        </div>

        <div class="form-group row">
          <label for="amount" class="col-md-2">Tarif:</label>
          <input
            v-model="price.amount"
            type="number"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !price.amount }"
            id="name"
            placeholder="Tarif"
            name="amount"
          />
        </div>

        <!-- <div class="form-group row">
          <label for="description" class="col-md-2">Description:</label>
          <input
            v-model="profile.description"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !profile.description }"
            id="description"
            placeholder="Description"
            name="description"
          />
        </div> -->

        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="form-check col-md-8">
            <input
              v-model="price.from_office"
              class="form-check-input"
              type="checkbox"
              id="from_office"
            />
            <label class="form-check-label" for="from_office">
              Depuis un office ?
            </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="form-check col-md-8">
            <input
              v-model="price.state"
              class="form-check-input"
              type="checkbox"
              id="gridCheck"
            />
            <label class="form-check-label" for="gridCheck"> Activé ? </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Enrégister</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'prices' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="row">
          <div
            class="form-group col-md-3"
            v-for="(action, index) in actions"
            :key="action.id + index"
          >
            <div class="form-check">
              <input
                v-model="profile.actions"
                :value="action.id"
                class="form-check-input"
                type="checkbox"
                :id="action.id"
              />
              <label class="form-check-label" :for="action.id">
                {{ action.name }}
              </label>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

import vSelect from "vue-select";

import {
  FETCH_COUNTRIES,
  FETCH_VISATYPES,
  UPDATE_PRICE,
} from "../../store/actions.type";

import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";

export default {
  name: "PriceEditForm",
  components: {
    vSelect,
  },
  data() {
    return {
      price: {
        amount: "",
        from_office: false,
        state: true,
        visatype: "",
        country: "",
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },
  async mounted() {
    this.price = this.$store.state.price.price;
    this.price.visatype = this.price.visa_type.id;
    this.price.country = this.price.country ? this.price.country.id : "";

    await this.getVisatypes();
    await this.getCountries();
  },
  computed: {
    ...mapGetters(["visatypes", "countries"]),
  },
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      const { amount, visatype } = this.price;
      if (!amount || !visatype) {
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(UPDATE_PRICE, {
          id: this.price.id,
          amount: this.price.amount,
          from_office: this.price.from_office,
          state: this.price.state,
          visa_type_id: this.price.visatype,
          country_id: this.price.country,
        })
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          //On réinitialise l'état
          (this.price = {
            amount: "",
            from_office: false,
            state: true,
            visatype: "",
            country: "",
          }),
            (this.submitted = false);
        })
        .catch((error) => {
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },

    getVisatypes() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_VISATYPES)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    getCountries() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_COUNTRIES)
        .catch(() => {})
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.vs__dropdown-toggle {
  height: 38px;
}
</style>
<style lang="scss" scoped>
.form-group {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>